import { Form, Input, Modal } from 'antd'
import * as React from 'react'
import { FormInstance } from 'antd/lib/form'

import { ContoCorrenteModel } from '../../models/ConfigurazioneModels'

import { IConfigurazioneService } from '../../services/ConfigurazioneService'
import container from '../../wires/Bootstrapper'
import SERVICE_IDENTIFIER from '../../wires/Identifiers'

import { TTFormItem } from '../shared/TTFormItem'
import { TTModalProps } from '../shared/TTModalProps'
import { TTSelect } from '../shared/TTSelect'
import { renderSelectKeyValue } from '../../services/shared/SelectOptionRenderUtils'
import { KeyValueModel } from '../../models/ModelBase'

interface ModalContoCorrenteProps extends TTModalProps {
    data?: ContoCorrenteModel
}

export class ModalContoCorrente extends React.Component<ModalContoCorrenteProps, any> {

    service: IConfigurazioneService
    formRef = React.createRef<FormInstance>()
    descRef = React.createRef<Input>()
    ibanRef = React.createRef<Input>()

    constructor(props) {
        super(props)
        this.service = container.get(SERVICE_IDENTIFIER.CONFIGURAZIONE_SERVICE)
    }

    componentDidMount() {
        this.descRef.current.focus()
    }

    closeModal = () => {
        this.formRef.current.resetFields()
        this.props.closeModal()
    }

    onSave = async () => {
        try {
            let data = await this.formRef.current.validateFields()
            let descrizione = data["Descrizione"]
            let iban = data["Iban"]
            let tipoCC = data["TipoCC"]

            let model = new ContoCorrenteModel()
            if (this.props.data != null)
                model = { ...this.props.data }

            model.Descrizione = descrizione
            model.Iban = iban
            model.ContoType = tipoCC
            let resp = await this.service.SaveContoCorrente(model)
            if (resp.IsValid == true) {
                this.closeModal()
                this.props.do()
            }
        } catch (err) {
            console.log(err)
        }
    }

    render() {
        let desc = ""
        let iban = ""
        let tipoCC = ""
        let p: KeyValueModel =  { Key: "Private", Value: "Private" }
        let b: KeyValueModel = { Key: "Business", Value: "Business" }

        let contolist = new Array<KeyValueModel>()
        contolist.push(p)
        contolist.push(b)
        if (this.props.data != null) {
            desc = this.props.data.Descrizione
            iban = this.props.data.Iban
            tipoCC = this.props.data.ContoType
            contolist = this.props.data.ContoList
        }
        

        return (
            <Modal
                title="Conto Corrente"
                visible={this.props.visible}
                onOk={this.onSave}
                onCancel={this.closeModal}>
                <Form ref={this.formRef}>
                    <TTFormItem name="Descrizione" label="Descrizione" initialValue={desc} rules={[{ required: true }]}>
                        <Input ref={this.descRef}  />
                    </TTFormItem>
                    <TTFormItem name="Iban" label="Iban" initialValue={iban} rules={[{ required: true }]}>
                        <Input ref={this.ibanRef}  />
                    </TTFormItem>
                    <TTFormItem name="TipoCC" label="Tipo CC" initialValue={tipoCC} rules={[{ required: true }]}>
                        <TTSelect size="small" value={tipoCC} showSearch allowClear>
                            {renderSelectKeyValue(contolist)}
                        </TTSelect>
                    </TTFormItem>
                </Form>
            </Modal>
        )
    }
}